// extracted by mini-css-extract-plugin
export default {"base":"ResultCard_base__WA9C2","content":"ResultCard_content__Gydld"};